import util from '../utils/util.js'

export function formatTime(date, status = 0) {
    date= util.beijingDay(date)
    // date = new Date(date)
    return util.formatTime(date,status)
}

export function priceFormat(val = 0) {
    return util.priceFormat(val)
}